/* 🤖 this file was generated by script */
export const wsolidiconCheckCircle = {
  name: 'check_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m5.2 8.7a1 1 0 0 0-1.4-1.4l-5.3 5.29-2.3-2.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0z" clip-rule="evenodd"/></svg>`,
  iconStyle: '',
};
